import request from '@/router/axios'
import env from '@/config/env'

// 获取分页
export const profitSharingList = (params) => {
  return request({
    url: env.ferryUrl + '/profitSharing/list',
    method: 'POST',
    data: params
  })
}

// 保存/修改
export const saveOrUpdatead = (params) => {
  return request({
    url: env.ferryUrl + '/profitSharing/saveOrUpdate',
    method: 'POST',
    data: params
  })
}

// 操作日志
export const profitSharingLog = (params) => {
  return request({
    url: env.ferryUrl + '/profitSharing/getProfitSharingLogPage',
    method: 'POST',
    data: params
  })
}
